<template>
  <section class="demande-home text-white px-6 py-20">
    <div class="content max-w-3xl mx-auto flex flex-col items-center text-center space-y-6">
      <h2 class="title text-3xl md:text-4xl font-bold">
        Vous avez besoin d’une inspection réglementaire et volontaire en exploitation pour votre projet ?
      </h2>
      <p class="subtitle text-lg md:text-xl">
        Contactez-nous pour un premier rendez-vous ou transmettez-nous votre projet.
      </p>
      <button 
        @click="demande" 
        class="btn-demande font-semibold px-6 py-3 rounded-lg border-2 border-white transition-all duration-300 hover:bg-white hover:text-black"
      >
        Demander plus d'information
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "DemandeHome",
  methods: {
    demande() {
      this.$router.push("/demande");
    }
  }
}
</script>

<style scoped>
.demande-home {
  margin-top: 50px;
  background: #0057E3 url("https://risk-control.fr/wp-content/uploads/2021/01/Graphisme.svg") no-repeat center right 80px;
  background-size: auto 100%;
}

.title {
  line-height: 1.3;
}

.subtitle {
  max-width: 600px;
}

.btn-demande {
  cursor: pointer;
  letter-spacing: 0.5px;
  background-color: rgb(38, 38, 230);
  color: aliceblue;
}

.btn-demande:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

@media (max-width: 768px) {
  .demande-home {
    background-position: center top;
    background-size: contain;
    padding: 40px 20px;
  }
  .title {
    font-size: 28px;
  }
  .subtitle {
    font-size: 16px;
  }
}
</style>
